export default __webpack_public_path__ + "static/media/blue-close.f331935a.svg";